<template>
  <div class="w-100">
    <error-banner v-if="error" :message="error"/>
    <client-details/>
    <pets-list/>
    <vet-details/>
    <emergency-contact/>
    <contract :invite="clientOnboardingInvite"/>
    <accept-marketing/>
    <button class="btn btn-secondary" @click="triggerSaveRegistration" v-bind:disabled="loading">
      Save & Complete
      <span v-if="loading" class="inline-loader"></span>
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import { MarketingSettingUpdateMixin } from '@/mixins/Registration/MarketingSettingUpdateMixin'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'
import ClientDetailsSection from './ClientDetails/ClientDetailsSection.vue'
import PetsList from './PetDetails/PetsList.vue'
import ClientVetContactSection from './ClientVetContactSection.vue'
import ClientEmergencyContactSection from './ClientEmergencyContactSection.vue'
import Contract from './Contract/Contract.vue'
import ClientAcceptMarketingSection from './ClientAcceptMarketingSection.vue'

export default {
  name: 'RegistrationForm',
  mixins: [ClientOnboardingInviteCacheMixin, MarketingSettingUpdateMixin],
  computed: {
    ...mapState('ApplicationEvents', ['updatedAcceptMarketingEvent']),
    ...mapState('RegistrationClients', ['loadingClient']),
    ...mapState('RegistrationClientAddress', ['loadingClientAddress']),
    ...mapState('RegistrationPets', ['loadingPets']),
    ...mapState('RegistrationAlternateContact', ['loadingAlternateContact']),
    ...mapState('RegistrationVetContact', ['loadingVetContact']),
    ...mapState('RegistrationPetNotes', ['loadingPetNotes']),
    ...mapState('RegistrationClientNotes', ['loadingClientNotes']),
    ...mapState('RegistrationMarketingSetting', ['loadingMarketingSetting']),
    ...mapState('RegistrationBreeds', ['loadingPetBreeds']),
    ...mapState('RegistrationSignature', ['loadingSignature']),
    inviteId () {
      return this.$route.query.id
    },
    loading () {
      return (
        this.loadingClient ||
        this.loadingClientAddress ||
        this.loadingPets ||
        this.loadingAlternateContact ||
        this.loadingVetContact ||
        this.loadingPetNotes ||
        this.loadingClientNotes ||
        this.loadingMarketingSetting ||
        this.loadingPetBreeds ||
        this.loadingSignature
      )
    }
  },
  methods: {
    ...mapMutations('ApplicationEvents', ['triggerSaveRegistration'])
  },
  components: {
    'client-details': ClientDetailsSection,
    'emergency-contact': ClientEmergencyContactSection,
    'vet-details': ClientVetContactSection,
    'accept-marketing': ClientAcceptMarketingSection,
    'pets-list': PetsList,
    'error-banner': ErrorBanner,
    contract: Contract
  }
}
</script>
